import { ImgHTMLAttributes } from "react";

import { translate } from "~utils";

type NoRequestsProps = {
  img: ImgHTMLAttributes<HTMLImageElement>;
  headerString: string;
  contentString: string;
};

export function NoRequests({ img, headerString, contentString }: NoRequestsProps) {
  return (
    <div
      css={{
        width: "100%",
        display: "flex",
        padding: "0 24px",
        flexDirection: "column",
        alignItems: "center",
        marginTop: 45,
        textAlign: "center",
      }}
    >
      <img css={{ width: 250, height: 250 }} {...img} />
      <h3 css={{ marginBottom: 24 }}>{headerString}</h3>
      <p css={{ whiteSpace: "pre-line", marginTop: 0, fontSize: 16 }}>{contentString}</p>
    </div>
  );
}

export function NoRequestsWithSearchTerm({
  searchTerm,
  page,
}: {
  searchTerm: string;
  page: string;
}) {
  return (
    <div className="mw-800" css={{ textAlign: "center" }}>
      <p css={{ fontWeight: 600 }}>
        {translate("INDEX_SEARCH_LOADING_HEADER", { name: searchTerm })}
      </p>
      <p>{translate("INDEX_SEARCH_LOADING_LABEL", { page })}</p>
    </div>
  );
}
